<div class="modal-header">
    <div class="modal-title">Release Report</div>
    <button type="button" class="close" id="release-modal-close" aria-label="Close" (click)="decline()">
        <span aria-hidden="true"></span>
    </button>
</div>

<div class="modal-body">
    <div class="row text-center font-italic">
        <p class="col-md-12 font-size-18">
            You have chosen to release <strong>{{businessName}}</strong> report to a 3rd party.
        </p>

        <p class="col-md-12 font-size-16" *ngIf="userService.isOrganizationUser()">
            Please enter the recipient name and email address below. The recipient will receive a link to download the
            report. In order to download, the recipient must agree to abide by the release terms and indemnify both Internal
            Valuation, LLC and the <strong>{{userService.getOrganizationName()}}</strong> (Report Generator) from any liability from relying on the Report.
        </p>

        <p class="col-md-12 font-size-16" *ngIf="!userService.isOrganizationUser()">
            Please enter the recipient name and email address below. The recipient will receive a link to download the
            report. In order to download, the recipient must agree to abide by the release terms and indemnify both Internal
            Valuation, LLC and <strong>{{userService.getUserFullName()}}</strong> (Report Generator) from any liability from relying on the Report.
        </p>

    </div>

    <form #releaseForm="ngForm" novalidate="novalidate">
        <div class="row mt-2">
            <div class="col-md-6">
                <div class="label">Name:</div>
                <input type="text" class="input input__large input__blue" [(ngModel)]="releaseObj.NAME" #NAME="ngModel"
                    name="NAME" required>
            </div>

            <div class="col-md-6">
                <div class="label">Email:</div>
                <input type="text" class="input input__large input__blue" [(ngModel)]="releaseObj.EMAIL"
                    #EMAIL="ngModel" name="EMAIL" [pattern]="commonService.emailPattern" required>
                <ng-container
                    *ngIf="(!EMAIL.valid && !EMAIL.untouched) && (EMAIL.errors?.required || EMAIL.errors?.pattern)">
                    <div *ngIf="!EMAIL.errors?.required && EMAIL.errors?.pattern" class="error-text">The email you
                        entered isn’t correct. Please check your email.</div>
                </ng-container>
            </div>
        </div>
    </form>

</div>

<div class="modal-footer">
    <button type="button" id="release-modal-cancel" class="button secondary__button large__button"
        (click)="decline()">Cancel</button>
    <button type="button" id="release-modal-continue" class="button primary__button large__button"
        (click)="confirm()" [disabled]="!releaseForm.valid">Release Report</button>
</div>
